import { defineMessages } from 'react-intl';

/**
 * The copy of the full videos and the motion artwork while they work, when they are ready and when
 * they fail (spec 2026-10-05 §6.6, §9.3; design s10, s5): the stage list of the Studio result, the
 * parts line of the song page card and of "Working on", the fail copy of the new fail codes and the
 * refund line.
 */
export const fullVideoProgressMessages = defineMessages({
  // ---- the stage list (s10) ----
  lyricsDone: { id: 'app.sml.promote.fullVideo.stage.lyricsDone', defaultMessage: 'Synced the lyrics' },
  lyricsNow: { id: 'app.sml.promote.fullVideo.stage.lyricsNow', defaultMessage: 'Syncing the lyrics' },
  lyricsWait: { id: 'app.sml.promote.fullVideo.stage.lyricsWait', defaultMessage: 'Sync the lyrics' },
  songDone: { id: 'app.sml.promote.fullVideo.stage.songDone', defaultMessage: 'Read the song' },
  songNow: { id: 'app.sml.promote.fullVideo.stage.songNow', defaultMessage: 'Reading the song' },
  songFacts: { id: 'app.sml.promote.fullVideo.stage.songFacts', defaultMessage: '{length}, {bpm} BPM' },
  planDone: { id: 'app.sml.promote.fullVideo.stage.planDone', defaultMessage: 'Planned the video' },
  planNow: { id: 'app.sml.promote.fullVideo.stage.planNow', defaultMessage: 'Planning the video' },
  planWait: { id: 'app.sml.promote.fullVideo.stage.planWait', defaultMessage: 'Plan the video' },
  renderNow: { id: 'app.sml.promote.fullVideo.stage.renderNow', defaultMessage: 'Rendering part {part} of {total}' },
  renderDone: {
    id: 'app.sml.promote.fullVideo.stage.renderDone',
    defaultMessage: '{total, plural, one {Rendered # part} other {Rendered # parts}}',
  },
  renderWait: { id: 'app.sml.promote.fullVideo.stage.renderWait', defaultMessage: 'Render the video' },
  joinWait: { id: 'app.sml.promote.fullVideo.stage.joinWait', defaultMessage: 'Join and check' },
  joinNow: { id: 'app.sml.promote.fullVideo.stage.joinNow', defaultMessage: 'Joining and checking' },
  joinHint: {
    id: 'app.sml.promote.fullVideo.stage.joinHint',
    defaultMessage: 'One MP4 with the master, then the spec check',
  },
  etaLong: {
    id: 'app.sml.promote.fullVideo.etaLong',
    defaultMessage:
      '{minutes, plural, one {About # minute left. You can leave this page.} other {About # minutes left. You can leave this page.}}',
  },
  leaveOnly: { id: 'app.sml.promote.fullVideo.leaveOnly', defaultMessage: 'You can leave this page.' },
  keepsGoing: { id: 'app.sml.promote.fullVideo.keepsGoing', defaultMessage: 'It keeps going when you close the page.' },
  emailYou: { id: 'app.sml.promote.fullVideo.emailYou', defaultMessage: 'We email you when it is ready' },

  // ---- the parts line (song page card, Working on) ----
  etaShort: { id: 'app.sml.promote.fullVideo.etaShort', defaultMessage: 'about {minutes} min left' },
  waitsForVisualizer: {
    id: 'app.sml.promote.fullVideo.waitsFor.visualizer',
    defaultMessage: 'Waits for your visualizer',
  },
  waitsForLyricVideo: {
    id: 'app.sml.promote.fullVideo.waitsFor.lyricVideo',
    defaultMessage: 'Waits for your lyric video',
  },
  waitsForMusicVideo: {
    id: 'app.sml.promote.fullVideo.waitsFor.musicVideo',
    defaultMessage: 'Waits for your music video',
  },

  // ---- the failure (s10) ----
  refund: {
    id: 'app.sml.promote.fullVideo.refund',
    defaultMessage: '{credits, plural, one {Your # credit came back.} other {Your # credits came back.}}',
  },
  failTooLong: { id: 'app.sml.promote.fullVideo.fail.tooLong', defaultMessage: 'It took too long to make.' },
  failRenderFailed: {
    id: 'app.sml.promote.fullVideo.fail.renderFailed',
    defaultMessage: 'A part of the video did not render.',
  },
  failLyricsNotSynced: {
    id: 'app.sml.promote.fullVideo.fail.lyricsNotSynced',
    defaultMessage: 'The lyrics did not sync in 30 minutes.',
  },
  failBankTooSmall: {
    id: 'app.sml.promote.fullVideo.fail.bankTooSmall',
    defaultMessage: 'The clip bank is too small for a music video.',
  },
  failAnalysis: { id: 'app.sml.promote.fullVideo.fail.analysis', defaultMessage: 'MUSIC24 could not read the song.' },
  failSpec: { id: 'app.sml.promote.fullVideo.fail.spec', defaultMessage: 'The file did not pass the spec check.' },
  failPlan: { id: 'app.sml.promote.fullVideo.fail.plan', defaultMessage: 'MUSIC24 could not plan this video.' },
  failStalled: { id: 'app.sml.promote.fullVideo.fail.stalled', defaultMessage: 'It stopped and did not start again.' },
});
